<template>
  <el-select
    v-model="select"
    :placeholder="`${$t('feed.settings.metaSource.newSource.form.preSourcesDictionary')} ${sourceName.toLowerCase()}`"
    v-if="!getDisabled(source)"
    filterable
    @change="onChange"
    class="meta-select"
  >
    <el-option :label="source.username" :value="source.id" v-for="source in sourcesByNet" :key="source.id"></el-option>
  </el-select>
</template>

<script>
  /*
    Network source selection component for meta source
  */

  export default {
    name: 'NetSource',
    props: {
      source: {
        type: Object
      },
      sourcesByNet: {
        type: Array
      },
      net: {
        type: String
      },
      sourceName: {
        type: String
      },
    },
    data() {
      return {
        select: '',
      };
    },
    methods: {
      onChange() {
        this.$emit('setSelectedSource', {select: this.select, net: this.net, sourceId: this.source ? this.source.id : 0});
      },
      getDisabled(source) {
        if (source === null) {
          return false;
        }

        if (source.disabled === undefined) {
          return true;
        }

        return source.disabled;
      },
    },
  };
</script>

<style>
  .meta-select .el-select .el-input {
    width: 100%;
  }
</style>
